import React from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message } from '@/components';
import { RootStore, meeting } from '@/models';
import * as API from '@/api';
import styles from './index.less';
import classNames from 'classnames';
import ActionBtn from '../ActionBtn';

interface Props extends Partial<Pick<RootStore, 'rtc' | 'user'>> {
  RTCInstance?: RootStore['rtc'];
  user?: RootStore['user'];
}
const MicrophoneBtn: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
  };
})(
  observer((props) => {
    const { RTCInstance, user } = props;
    const { formatMessage } = useIntl();

    const openAudio = React.useCallback(async () => {
      if (RTCInstance?.breakLineReconnecting) {
        return;
      }
      if (isPad && RTCInstance?.micIsNotAvailable) {
        message.info({
          content: formatMessage({ id: 'NO_DEVICE' }),
          icon: null,
        });
        return;
      }
      if (RTCInstance?.isOpenAudioLoading) {
        return;
      }
      RTCInstance!.isOpenAudioLoading = true;
      const isOpen = RTCInstance?.isOpenAudio
        ? API.DEVICE_STATUS_REQUEST.CLOSE
        : API.DEVICE_STATUS_REQUEST.OPEN;
      // 先 quiet 允许开启后，再上报设备状态
      try {
        await user?.quiet(String(RTCInstance?.cid), isOpen);
        await user?.updateDeviceStatus(String(RTCInstance?.cid), API.DEVICE_TYPE.AUDIO, isOpen);
        // if (RTCInstance?.isOpenAudio) {
        //   meeting?.clearSpeakerYxUid(); // 清除本地当前说话人
        // }
        RTCInstance?.isOpenAudio ? await RTCInstance.closeMic() : await RTCInstance?.openMic(true);
      } catch (err: any) {
        if (err.status === 5005) {
          message.info({
            content: formatMessage({ id: 'NOT_ALLOWED_TURNED_ON_DEVICE' }),
            noIcon: true,
          });
        } else {
          message.info({
            content: err.msg || err.message,
            noIcon: true,
          });
        }
      } finally {
        RTCInstance!.isOpenAudioLoading = false;
      }
    }, [RTCInstance]);

    return (
      <ActionBtn
        tooltip={formatMessage({
          id: RTCInstance?.micIsNotAvailable
            ? 'availableMicrophoneIsNotDetected'
            : RTCInstance?.isOpenAudio
            ? 'turnOffTheMicrophone'
            : 'turnOnTheMicrophone',
        })}
        title={formatMessage({ id: 'MICROPHONE' })}
        className={classNames(styles['micBtn'], {
          [styles.on]: RTCInstance?.isOpenAudio,
          [styles.disable]: RTCInstance?.breakLineReconnecting,
        })}
        onClick={openAudio}
      >
        {RTCInstance?.isOpenAudio && (
          <Icon className={styles.icon} name="icon-micro_solid" mode="symbol" />
        )}
        {RTCInstance?.micIsNotAvailable && (
          <>
            <Icon className={styles.warn} name="icon-warming_solid" mode="symbol" />
            <Icon className={styles['not-available']} name="icon-micro_noequipment" />
          </>
        )}
        {!RTCInstance?.isOpenAudio && !RTCInstance?.micIsNotAvailable && (
          <Icon className={styles.icon} name="icon-micro_off_solid" mode="symbol" />
        )}
      </ActionBtn>
    );
  })
);

export default MicrophoneBtn;
